
import Vue, { PropType } from 'vue'
import { ContestWinner } from '@/model/ContestWinner'
import ProjectItem from '@/components/project/ItemCard.vue'

export default Vue.extend({
  name: 'ContestWinnersPlaces',
  components: {
    ProjectItem,
  },
  props: {
    winnersPlaces: {
      type: Array as PropType<ContestWinner[]>,
    },
  },
  data: () => ({}),
  methods: {
    winnerTrophyColour: function (place: number): string {
      switch (place) {
        case 1:
          return 'amber'
        case 2:
          return 'grey'
        case 3:
          return 'brown'
        case 999: // Optional award
          return 'silver'
      }
      return 'silver'
    },
    winnerOrdinalPlace: function (place: number): string {
      switch (place) {
        case 1:
          return `${place}st place`
        case 2:
          return `${place}nd place`
        case 3:
          return `${place}rd place`
        case 999:
          return 'Optional award'
      }
      return `${place}th place`
    },
  },
})
